/* eslint-disable @altermaind/you-shall-not-pass */
// Auto-generated from OpenAPI enums. Do not edit manually.

export enum Sort {
  HIGHESTRATING = 'highestRating',
  MOSTRECENT = 'mostRecent',
}

export enum Filter {
  ISCOMPLETED = 'isCompleted',
  ISSAVED = 'isSaved',
  ISINPROGRESS = 'isInProgress',
}

export enum ContentType {
  VIDEO = 'VIDEO',
  PDF = 'PDF',
  QUIZ = 'QUIZ',
}

export enum SkillCategory {
  SOFT_SKILL = 'SOFT_SKILL',
  HARD_SKILL = 'HARD_SKILL',
}

export enum EnrollmentStatus {
  STARTED = 'STARTED',
  PROGRESS = 'PROGRESS',
  FINISHED = 'FINISHED',
}
